import React from 'react';
import { withRouter } from 'react-router';
import { Route, Redirect } from 'react-router-dom';
import util from '@/util/common'

const AuthRouter = ({ component: Component, ...rest }) => {
	const isLogged = util.isLogin() ? true : false;
	return <Route 
		{...rest} 
		render={props => (isLogged ? <Component {...props} /> : <Redirect to={'/login'} />)} 
	/>;
};

export default withRouter(AuthRouter);
